module.exports = __webpack_public_path__ + "img/0Q3A5610_L_WoodMatted.5334e099.jpg";